import { render } from "./UpcomingAlerts.vue?vue&type=template&id=00eaedd4&scoped=true"
import script from "./UpcomingAlerts.vue?vue&type=script&lang=js"
export * from "./UpcomingAlerts.vue?vue&type=script&lang=js"

import "./UpcomingAlerts.vue?vue&type=style&index=0&id=00eaedd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eaedd4"]])

export default __exports__